module.exports = __webpack_public_path__ + "01_cheek.7a4a565d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer2/01_cheek.png
// module id = mwCL
// module chunks = 0